import { render, staticRenderFns } from "./details.vue?vue&type=template&id=99dbf7b2&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/web/account/settings/_content.scss?vue&type=style&index=0&id=99dbf7b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dbf7b2",
  null
  
)

export default component.exports